<template>
	<div class="extract-header">
		<div class="content clearfix">
			<div class="logo-box clearfix">
				<img src="../../assets/images/evidenceExtraction/detail/legalxhcian_zjtqzyxt_logo.png">
			</div>
			<div class="status-box" @click="removeInfo">您好&nbsp;&nbsp;|&nbsp;&nbsp;<a :href="$route.path.indexOf('en')==1?'/en/evidenceExtraction':'/cn/evidenceExtraction'">返回首页</a></div>
		</div>
	</div>
</template>

<script>
	export default{
		data () {
			return {

			}
		},
		mounted () {
			// this.init();
		},
		methods:{
			removeInfo () {
				sessionStorage.removeItem('extractInfo')
				sessionStorage.removeItem('evdenceQuery')
			}
		}
	}
</script>

<style scoped>
.extract-header{
	width: 100%;
	height: 70px;
	background-color: #152956;
}
.extract-header .content{
	height: 100%;
	width: 1200px;
	margin:0 auto;
	color:#fff;
}
.extract-header .logo-box{
	float: left;
	height: 100%;
}
.extract-header .logo-box img{
	float: left;
	margin-top: 22px;
}
.extract-header .logo-box h4{
	float: left;
	font-size: 16px;
	line-height: 70px;
	margin-left: 20px;
	font-weight: 400;
}
.extract-header .status-box{
	float: right;
	height: 100%;
	line-height: 70px;
	font-size: 14px;
}
.extract-header .status-box a{
	color:#fff;
}
</style>
